import FormControl from '@mui/material/FormControl';
import MuiFormControlLabel, {
  type FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import MuiFormHelperText from '@mui/material/FormHelperText';
import MuiRadio from '@mui/material/Radio';
import type { RadioGroupProps } from '@mui/material/RadioGroup';
import MuiRadioGroup from '@mui/material/RadioGroup';
import type { ForwardedRef, PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import { useId } from 'react';

type Props = {
  error?: string;
} & RadioGroupProps;

export const RadioGroup = forwardRef(function RadioGroup(
  { children, error, ...props }: PropsWithChildren<Props>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const errorId = useId();

  return (
    <FormControl error={!!error}>
      <MuiRadioGroup ref={ref} aria-describedby={errorId} {...props}>
        {children}
      </MuiRadioGroup>
      {error && <MuiFormHelperText id={errorId}>{error}</MuiFormHelperText>}
    </FormControl>
  );
});

export const Radio = (
  props: Omit<FormControlLabelProps & { readOnly?: boolean }, 'control'>,
) => {
  return <MuiFormControlLabel {...props} control={<MuiRadio />} />;
};
